import { render, staticRenderFns } from "./headIcon.vue?vue&type=template&id=1c825726&"
import script from "./headIcon.vue?vue&type=script&lang=js&"
export * from "./headIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports